/**
 * @generated SignedSource<<04fda81fa14715d21f290814c9ed61d9>>
 * @relayHash eabecc9fa9096315fa62703f02e156f6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 53d0a90a1be73201bf841505f2041a171880c7f58fea4507b79c103078db316c

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { QueueSettingsEmbeddedViewQuery } from './QueueSettingsEmbeddedViewQuery.graphql';

const node: PreloadableConcreteRequest<QueueSettingsEmbeddedViewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "53d0a90a1be73201bf841505f2041a171880c7f58fea4507b79c103078db316c",
    "metadata": {},
    "name": "QueueSettingsEmbeddedViewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
